

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDeveloperService } from 'api';



// Async thunk for fetching dashboard data
export const fetchDeveloperServiceData = createAsyncThunk(
  'developerService',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchDeveloperService();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dashboard data');
    }
  }
);

const developerServiceSlice = createSlice({
  name: 'developerService',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeveloperServiceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeveloperServiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDeveloperServiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = developerServiceSlice.actions;
export default developerServiceSlice.reducer;
